import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import { ID_FILTER_SEARCH } from "../../pages/cluster/constants/ClustersFilters";
import {
    ID_FILTER_APPLIEDON,
    ID_FILTER_ORDER,
    ID_FILTER_PRINTOUTTYPE,
    ID_FILTER_SEGMENT,
    ID_FILTER_SPECIAL,
    ID_FILTER_VOICE
} from "../../pages/cluster/constants/VoicesFilters";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useClusterVoicesRepository = () => {
    const { GET, POST, PUT, DELETE } = useApi();

    const PATH = "/finance/cluster-voice"
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

    function getVoices(id: string, offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let appliedOn = getFilterValue(ID_FILTER_APPLIEDON, filterDefs);
        let printoutType = getFilterValue(ID_FILTER_PRINTOUTTYPE, filterDefs);
        let special = getFilterValue(ID_FILTER_SPECIAL, filterDefs);
        let ord = getFilterValue(ID_FILTER_ORDER, filterDefs);
        let voice: any = getFilterValue(ID_FILTER_VOICE, filterDefs);
        let voiceKey = voice !== undefined ? voice.key : undefined;
        let segment = getFilterValue(ID_FILTER_SEGMENT, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            appliedOn: appliedOn,
            printoutType: printoutType,
            special: special,
            ord: ord,
            voice: voiceKey,
            segment: segment,
            legalEntities: allLegalEntities
        }

        return GET(`${PATH}/${id}/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getUnusedVoiceItems(printoutType: string, search: string, clusterId: string, legalEntity: string, dealer: string): Promise<HTTPGenericResponse> {
        let params = {
            printoutType: printoutType ? printoutType : undefined,
            search: search ? search : undefined,
            clusterId : clusterId,
            limit: 1000,
            legalEntities: [legalEntity],
            dealers: [dealer]
        }
        return GET(`${PATH}/unused-voice-items`, { params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getAllVoiceItems(printoutType: string, search: string, legalEntity: string, dealer: string): Promise<HTTPGenericResponse> {
        let params = {
            printoutType: printoutType ? printoutType : undefined,
            search: search ? search : undefined,
            limit: 1000,
            legalEntities: [legalEntity],
            dealers: [dealer]
        }
        return GET(`${PATH}/all-voice-items`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }
    function createVoice(idCluster: number, voice: any): Promise<HTTPGenericResponse> {
        return POST(`${PATH}/${idCluster}`, voice, {}, true);
    }

    function updateVoice(idCluster: number,idVoice: number, voice: any): Promise<HTTPGenericResponse> {
        return PUT(`${PATH}/${idCluster}/${idVoice}`, voice, {}, true);
    }

    function deleteVoice(idVoice: number): Promise<HTTPGenericResponse> {
        return DELETE(`${PATH}/${idVoice}`, undefined, true)
    }

    function getAvailableSegments(printoutType: string, search: string, clusterId: string,  voice: string): Promise<HTTPGenericResponse> {
        let params = {
            printoutType: printoutType ? printoutType : undefined,
            search: search ? search : undefined,
            clusterId : clusterId,
            voice : voice,
            limit: 1000
        }
        return GET(`${PATH}/available-segments`, { params });
    }

    function hasSegments(clusterId: any): Promise<HTTPGenericResponse> {
        let params = {
            legalEntities: allLegalEntities
        }
        return GET(`${PATH}/has-segments/${clusterId}`,{ params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    return { getVoices, getAllVoiceItems, getUnusedVoiceItems, createVoice, updateVoice, deleteVoice, getAvailableSegments, hasSegments };
}